import { useHistory } from 'react-router-dom';

import Button from 'components/Button/Button';
import Image from 'components/Image';

import image404 from './assets/404.png';

import './style.scss';

const FourOhFour = () => {
  const history = useHistory();

  return (
    <div className="container container--error">
      <div className="row">
        <div className="col">
          <Image
            alt="404 Not found"
            className="e404--main-img"
            src={ image404 }
          />
          <h1 className="e404--title">Page not found</h1>
          <p className="e404--desc">The page you’re looking for doesn’t seem to exist.</p>

          <Button
            className="btn--hover-bg-purple"
            onClick={ () => history.push('/') }
            size="s"
            sizeMin={ 150 }
            theme="white"
          >
            Back home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FourOhFour;
